import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubble4: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bubble-4, message, chat"><path d="M19.252 3C20.2185 3 21.002 3.7835 21.002 4.75V18.25C21.002 19.2165 20.2185 20 19.252 20H8.03875C7.99189 20 7.94598 20.0132 7.90625 20.038L4.14945 22.386C3.91825 22.5305 3.62684 22.5382 3.38838 22.406C3.14991 22.2738 3.00195 22.0226 3.00195 21.75V4.75C3.00195 3.7835 3.78546 3 4.75195 3H19.252Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBubble4;
